import { TMableEvent } from '@/core/constants/event_types/base_mable_event';
import { RetryMetadata } from '@/core/constants/event_types/extended_mable_event';

export function addEntryToRetryInfo(
  entry: RetryMetadata,
  mableEvent: TMableEvent,
) {
  mableEvent.md.emd = mableEvent.md.emd || {};
  mableEvent.md.emd.retryInfo = mableEvent.md.emd.retryInfo || [];
  mableEvent.md.emd.retryInfo.push(entry);
  return mableEvent;
}
